<template>
  <ul class="menu flex flex-row">
    <li>
      <router-link :to="{ name: 'home' }" class="nav-link">Home</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'about' }" class="nav-link">About</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'resume' }" class="nav-link"
        >Resume</router-link
      >
    </li>
    <li>
      <router-link :to="{ name: 'skills' }" class="nav-link nav-link-last"
        >Skills</router-link
      >
    </li>
  </ul>
</template>
<script>
import { onMounted } from "vue";
import gsapAnimation from "../../composables/gsapAnimation";
export default {
  setup() {
    const { stick } = gsapAnimation({});
    onMounted(() => (window.onscroll = () => stick()));
    return { stick };
  },
};
</script>
